module.exports = __webpack_public_path__ + "static/img/price-bg.b824d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price-bg.png
// module id = pR8Y
// module chunks = 0